"use strict";

angular.module("vendor")
.factory("InvoiceSelectorUnregisteredServiceFactory", function(
    $resource, FlashBag, gettextCatalog, appConfig
) {
    return (function(listingUrl, urlParams) {
        this.filterParams = urlParams;
        this.listingResource = $resource(appConfig.API_SERVER + listingUrl + ":id/", {id: "@id"}, {
            query: {
                method: "GET",
                isArray: false,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            },
            save: {
                method: "POST",
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            },
            update: {
                method: "PATCH",
                ignoreLoadingBar: true,
                interceptor: {responseError: FlashBag.responseErrorInterceptor}
            }
        });

        this.query = function(params) {
            angular.extend(params, this.filterParams);
            return this.listingResource.query(params);
        };

        this.updateAllSelected = function(params) {
            angular.extend(params, this.filterParams);
            return this.listingResource.save(params);
        };

        this.updateSingleSelected = function(referenceId, selected, id) {
            var params = {
                reference_id: referenceId,
                selected: selected,
                id: id
            };
            angular.extend(params, this.filterParams);
            return this.listingResource.update(params);
        };

        this.getStatusHtmlContent = function() {
            return gettextCatalog.getString("Invoice status help tip html");
        };
    });
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/model-management/invoice-selector-unregistered-service.factory.js
// module id = 857
// module chunks = 0